import { SmartSendItemsCache } from '../cache/SmartSendItemsCache';
import PreQuoteValidation from '../helpers/SmartSendValidation';
import { isQuotableItem } from './ContextFunctions';
import { SmartSendItemState } from './SmartSendContextModels';

export function GetClientSideFailedValidation(ids: string[]) {
  return ids
    .map((item) => SmartSendItemsCache.find((x) => x.Id === item))
    .filter(isQuotableItem)
    .map((item) => {
      return { key: item.Id, value: PreQuoteValidation(item, null) };
    })
    .filter((x) => x.value.Errors.length > 0)
    .map((x) => {
      return {
        key: x.key,
        value: { validation: x.value, state: 'ERROR', unsaved: [] } as unknown as SmartSendItemState
      };
    });
}
